import React from 'react';

const ServicosHero: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-r from-color-primary to-color-secondary text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Serviços da Federação</h1>
        <p className="text-lg text-white/90 max-w-2xl mx-auto">
          Soluções profissionais para impulsionar sua carreira e sua presença no mercado.
        </p>
      </div>
    </section>
  );
};

export default ServicosHero;
